export const language = {
  en: "English",
  es: "Spanish",
  hi: "Hindi",
  ja: "Japanese",
  zh: "Chinese",
};